export default __webpack_public_path__ + "e1b8c1d87c35fda179b0c5a4d118759d.svg";